export const COUNTRIES = [
	{ key: "", value: "", flag: "", text: "" },
	{ key: "af", value: "af", flag: "af", text: "Afghanistan" },
	{ key: "al", value: "al", flag: "al", text: "Albania" },
	{ key: "dz", value: "dz", flag: "dz", text: "Algeria" },
	{ key: "ad", value: "ad", flag: "ad", text: "Andorra" },
	{ key: "ao", value: "ao", flag: "ao", text: "Angola" },
	{ key: "ai", value: "ai", flag: "ai", text: "Anguilla" },
	{ key: "ag", value: "ag", flag: "ag", text: "Antigua e Barbuda" },
	{ key: "sa", value: "sa", flag: "sa", text: "Arabia Saudita" },
	{ key: "ar", value: "ar", flag: "ar", text: "Argentina" },
	{ key: "am", value: "am", flag: "am", text: "Armenia" },
	{ key: "aw", value: "aw", flag: "aw", text: "Aruba" },
	{ key: "au", value: "au", flag: "au", text: "Australia" },
	{ key: "at", value: "at", flag: "at", text: "Austria" },
	{ key: "az", value: "az", flag: "az", text: "Azerbaigian" },
	{ key: "bs", value: "bs", flag: "bs", text: "Bahamas" },
	{ key: "bh", value: "bh", flag: "bh", text: "Bahrein" },
	{ key: "bd", value: "bd", flag: "bd", text: "Bangladesh" },
	{ key: "bb", value: "bb", flag: "bb", text: "Barbados" },
	{ key: "be", value: "be", flag: "be", text: "Belgio" },
	{ key: "bz", value: "bz", flag: "bz", text: "Belize" },
	{ key: "bj", value: "bj", flag: "bj", text: "Benin" },
	{ key: "bm", value: "bm", flag: "bm", text: "Bermuda" },
	{ key: "bt", value: "bt", flag: "bt", text: "Bhutan" },
	{ key: "by", value: "by", flag: "by", text: "Bielorussia" },
	{ key: "mm", value: "mm", flag: "mm", text: "Birmania" },
	{ key: "bo", value: "bo", flag: "bo", text: "Bolivia" },
	{ key: "ba", value: "ba", flag: "ba", text: "Bosnia ed Erzegovina" },
	{ key: "bw", value: "bw", flag: "bw", text: "Botswana" },
	{ key: "br", value: "br", flag: "br", text: "Brasile" },
	{ key: "bn", value: "bn", flag: "bn", text: "Brunei" },
	{ key: "bg", value: "bg", flag: "bg", text: "Bulgaria" },
	{ key: "bf", value: "bf", flag: "bf", text: "Burkina Faso" },
	{ key: "bi", value: "bi", flag: "bi", text: "Burundi" },
	{ key: "kh", value: "kh", flag: "kh", text: "Cambogia" },
	{ key: "cm", value: "cm", flag: "cm", text: "Camerun" },
	{ key: "ca", value: "ca", flag: "ca", text: "Canada" },
	{ key: "cv", value: "cv", flag: "cv", text: "Capo Verde" },
	{ key: "td", value: "td", flag: "td", text: "Ciad" },
	{ key: "cl", value: "cl", flag: "cl", text: "Cile" },
	{ key: "cn", value: "cn", flag: "cn", text: "Cina" },
	{ key: "cy", value: "cy", flag: "cy", text: "Cipro" },
	{ key: "va", value: "va", flag: "va", text: "Città del Vaticano" },
	{ key: "co", value: "co", flag: "co", text: "Colombia" },
	{ key: "km", value: "km", flag: "km", text: "Comore" },
	{ key: "kp", value: "kp", flag: "kp", text: "Corea del Nord" },
	{ key: "kr", value: "kr", flag: "kr", text: "Corea del Sud" },
	{ key: "ci", value: "ci", flag: "ci", text: "Costa d'Avorio" },
	{ key: "cr", value: "cr", flag: "cr", text: "Costa Rica" },
	{ key: "hr", value: "hr", flag: "hr", text: "Croazia" },
	{ key: "cu", value: "cu", flag: "cu", text: "Cuba" },
	{ key: "dk", value: "dk", flag: "dk", text: "Danimarca" },
	{ key: "dm", value: "dm", flag: "dm", text: "Dominica" },
	{ key: "ec", value: "ec", flag: "ec", text: "Ecuador" },
	{ key: "eg", value: "eg", flag: "eg", text: "Egitto" },
	{ key: "sv", value: "sv", flag: "sv", text: "El Salvador" },
	{ key: "ae", value: "ae", flag: "ae", text: "Emirati Arabi Uniti" },
	{ key: "er", value: "er", flag: "er", text: "Eritrea" },
	{ key: "ee", value: "ee", flag: "ee", text: "Estonia" },
	{ key: "et", value: "et", flag: "et", text: "Etiopia" },
	{ key: "fj", value: "fj", flag: "fj", text: "Figi" },
	{ key: "ph", value: "ph", flag: "ph", text: "Filippine" },
	{ key: "fi", value: "fi", flag: "fi", text: "Finlandia" },
	{ key: "fr", value: "fr", flag: "fr", text: "Francia" },
	{ key: "ga", value: "ga", flag: "ga", text: "Gabon" },
	{ key: "gm", value: "gm", flag: "gm", text: "Gambia" },
	{ key: "ge", value: "ge", flag: "ge", text: "Georgia" },
	{
		key: "gs",
		value: "gs",
		flag: "gs",
		text: "Georgia del Sud e Isole Sandwich Australi",
	},
	{ key: "de", value: "de", flag: "de", text: "Germania" },
	{ key: "gh", value: "gh", flag: "gh", text: "Ghana" },
	{ key: "jm", value: "jm", flag: "jm", text: "Giamaica" },
	{ key: "jp", value: "jp", flag: "jp", text: "Giappone" },
	{ key: "gi", value: "gi", flag: "gi", text: "Gibilterra" },
	{ key: "dj", value: "dj", flag: "dj", text: "Gibuti" },
	{ key: "jo", value: "jo", flag: "jo", text: "Giordania" },
	{ key: "gr", value: "gr", flag: "gr", text: "Grecia" },
	{ key: "gd", value: "gd", flag: "gd", text: "Grenada" },
	{ key: "gl", value: "gl", flag: "gl", text: "Groenlandia" },
	{ key: "gp", value: "gp", flag: "gp", text: "Guadalupa" },
	{ key: "gu", value: "gu", flag: "gu", text: "Guam" },
	{ key: "gt", value: "gt", flag: "gt", text: "Guatemala" },
	{ key: "gn", value: "gn", flag: "gn", text: "Guinea" },
	{ key: "gw", value: "gw", flag: "gw", text: "Guinea-Bissau" },
	{ key: "gq", value: "gq", flag: "gq", text: "Guinea Equatoriale" },
	{ key: "gy", value: "gy", flag: "gy", text: "Guyana" },
	{ key: "gf", value: "gf", flag: "gf", text: "Guyana francese" },
	{ key: "ht", value: "ht", flag: "ht", text: "Haiti" },
	{ key: "hn", value: "hn", flag: "hn", text: "Honduras" },
	{ key: "hk", value: "hk", flag: "hk", text: "Hong Kong" },
	{ key: "in", value: "in", flag: "in", text: "India" },
	{ key: "id", value: "id", flag: "id", text: "Indonesia" },
	{ key: "ir", value: "ir", flag: "ir", text: "Iran" },
	{ key: "iq", value: "iq", flag: "iq", text: "Iraq" },
	{ key: "ie", value: "ie", flag: "ie", text: "Irlanda" },
	{ key: "is", value: "is", flag: "is", text: "Islanda" },
	{ key: "bv", value: "bv", flag: "bv", text: "Isola Bouvet" },
	{ key: "cx", value: "cx", flag: "cx", text: "Isola di Natale" },
	{ key: "nf", value: "nf", flag: "nf", text: "Isola Norfolk" },
	{ key: "ax", value: "ax", flag: "ax", text: "Isole Åland" },
	{ key: "ky", value: "ky", flag: "ky", text: "Isole Cayman" },
	{ key: "cc", value: "cc", flag: "cc", text: "Isole Cocos (Keeling)" },
	{ key: "ck", value: "ck", flag: "ck", text: "Isole Cook" },
	{ key: "fo", value: "fo", flag: "fo", text: "Fær Øer" },
	{ key: "fk", value: "fk", flag: "fk", text: "Isole Falkland" },
	{ key: "hm", value: "hm", flag: "hm", text: "Isole Heard e McDonald" },
	{ key: "mp", value: "mp", flag: "mp", text: "Isole Marianne Settentrionali" },
	{ key: "mh", value: "mh", flag: "mh", text: "Isole Marshall" },
	{
		key: "um",
		value: "um",
		flag: "um",
		text: "Isole minori esterne degli Stati Uniti",
	},
	{ key: "pn", value: "pn", flag: "pn", text: "Isole Pitcairn" },
	{ key: "sb", value: "sb", flag: "sb", text: "Isole Salomone" },
	{ key: "vg", value: "vg", flag: "vg", text: "Isole Vergini Britanniche" },
	{ key: "vi", value: "vi", flag: "vi", text: "Isole Vergini Americane" },
	{ key: "il", value: "il", flag: "il", text: "Israele" },
	{ key: "it", value: "it", flag: "it", text: "Italia" },
	{ key: "kz", value: "kz", flag: "kz", text: "Kazakistan" },
	{ key: "ke", value: "ke", flag: "ke", text: "Kenya" },
	{ key: "kg", value: "kg", flag: "kg", text: "Kirghizistan" },
	{ key: "ki", value: "ki", flag: "ki", text: "Kiribati" },
	{ key: "kw", value: "kw", flag: "kw", text: "Kuwait" },
	{ key: "la", value: "la", flag: "la", text: "Laos" },
	{ key: "ls", value: "ls", flag: "ls", text: "Lesotho" },
	{ key: "lv", value: "lv", flag: "lv", text: "Lettonia" },
	{ key: "lb", value: "lb", flag: "lb", text: "Libano" },
	{ key: "lr", value: "lr", flag: "lr", text: "Liberia" },
	{ key: "ly", value: "ly", flag: "ly", text: "Libia" },
	{ key: "li", value: "li", flag: "li", text: "Liechtenstein" },
	{ key: "lt", value: "lt", flag: "lt", text: "Lituania" },
	{ key: "lu", value: "lu", flag: "lu", text: "Lussemburgo" },
	{ key: "mo", value: "mo", flag: "mo", text: "Macao" },
	{ key: "mk", value: "mk", flag: "mk", text: "Macedonia del Nord" },
	{ key: "mg", value: "mg", flag: "mg", text: "Madagascar" },
	{ key: "mw", value: "mw", flag: "mw", text: "Malawi" },
	{ key: "my", value: "my", flag: "my", text: "Malaysia" },
	{ key: "mv", value: "mv", flag: "mv", text: "Maldive" },
	{ key: "ml", value: "ml", flag: "ml", text: "Mali" },
	{ key: "mt", value: "mt", flag: "mt", text: "Malta" },
	{ key: "ma", value: "ma", flag: "ma", text: "Marocco" },
	{ key: "mq", value: "mq", flag: "mq", text: "Martinica" },
	{ key: "mr", value: "mr", flag: "mr", text: "Mauritania" },
	{ key: "mu", value: "mu", flag: "mu", text: "Mauritius" },
	{ key: "yt", value: "yt", flag: "yt", text: "Mayotte" },
	{ key: "mx", value: "mx", flag: "mx", text: "Messico" },
	{ key: "fm", value: "fm", flag: "fm", text: "Micronesia" },
	{ key: "md", value: "md", flag: "md", text: "Moldavia" },
	{ key: "mn", value: "mn", flag: "mn", text: "Mongolia" },
	{ key: "me", value: "me", flag: "me", text: "Montenegro" },
	{ key: "ms", value: "ms", flag: "ms", text: "Montserrat" },
	{ key: "mz", value: "mz", flag: "mz", text: "Mozambico" },
	{ key: "na", value: "na", flag: "na", text: "Namibia" },
	{ key: "nr", value: "nr", flag: "nr", text: "Nauru" },
	{ key: "np", value: "np", flag: "np", text: "Nepal" },
	{ key: "ni", value: "ni", flag: "ni", text: "Nicaragua" },
	{ key: "ne", value: "ne", flag: "ne", text: "Niger" },
	{ key: "ng", value: "ng", flag: "ng", text: "Nigeria" },
	{ key: "nu", value: "nu", flag: "nu", text: "Niue" },
	{ key: "no", value: "no", flag: "no", text: "Norvegia" },
	{ key: "nc", value: "nc", flag: "nc", text: "Nuova Caledonia" },
	{ key: "nz", value: "nz", flag: "nz", text: "Nuova Zelanda" },
	{ key: "om", value: "om", flag: "om", text: "Oman" },
	{ key: "nl", value: "nl", flag: "nl", text: "Paesi Bassi" },
	{ key: "pk", value: "pk", flag: "pk", text: "Pakistan" },
	{ key: "pw", value: "pw", flag: "pw", text: "Palau" },
	{ key: "ps", value: "ps", flag: "ps", text: "Palestina" },
	{ key: "pa", value: "pa", flag: "pa", text: "Panama" },
	{ key: "pg", value: "pg", flag: "pg", text: "Papua Nuova Guinea" },
	{ key: "py", value: "py", flag: "py", text: "Paraguay" },
	{ key: "pe", value: "pe", flag: "pe", text: "Perù" },
	{ key: "pf", value: "pf", flag: "pf", text: "Polinesia francese" },
	{ key: "pl", value: "pl", flag: "pl", text: "Polonia" },
	{ key: "pr", value: "pr", flag: "pr", text: "Porto Rico" },
	{ key: "pt", value: "pt", flag: "pt", text: "Portogallo" },
	{ key: "mc", value: "mc", flag: "mc", text: "Monaco" },
	{ key: "qa", value: "qa", flag: "qa", text: "Qatar" },
	{ key: "gb", value: "gb", flag: "gb", text: "Regno Unito" },
	{ key: "cd", value: "cd", flag: "cd", text: "RD del Congo" },
	{ key: "cz", value: "cz", flag: "cz", text: "Rep. Ceca" },
	{ key: "cf", value: "cf", flag: "cf", text: "Rep. Centrafricana" },
	{ key: "cg", value: "cg", flag: "cg", text: "Rep. del Congo" },
	{ key: "do", value: "do", flag: "do", text: "Rep. Dominicana" },
	{ key: "re", value: "re", flag: "re", text: "La Riunione" },
	{ key: "ro", value: "ro", flag: "ro", text: "Romania" },
	{ key: "rw", value: "rw", flag: "rw", text: "Ruanda" },
	{ key: "ru", value: "ru", flag: "ru", text: "Russia" },
	{ key: "eh", value: "eh", flag: "eh", text: "Sahara Occidentale" },
	{ key: "kn", value: "kn", flag: "kn", text: "Saint Kitts e Nevis" },
	{ key: "lc", value: "lc", flag: "lc", text: "Saint Lucia" },
	{
		key: "sh",
		value: "sh",
		flag: "sh",
		text: "Sant'Elena, Ascensione e Tristan da Cunha",
	},
	{ key: "vc", value: "vc", flag: "vc", text: "Saint Vincent e Grenadine" },
	{ key: "pm", value: "pm", flag: "pm", text: "Saint-Pierre e Miquelon" },
	{ key: "ws", value: "ws", flag: "ws", text: "Samoa" },
	{ key: "as", value: "as", flag: "as", text: "Samoa Americane" },
	{ key: "sm", value: "sm", flag: "sm", text: "San Marino" },
	{ key: "st", value: "st", flag: "st", text: "São Tomé e Príncipe" },
	{ key: "sn", value: "sn", flag: "sn", text: "Senegal" },
	{ key: "rs", value: "rs", flag: "rs", text: "Serbia" },
	{ key: "sc", value: "sc", flag: "sc", text: "Seychelles" },
	{ key: "sl", value: "sl", flag: "sl", text: "Sierra Leone" },
	{ key: "sg", value: "sg", flag: "sg", text: "Singapore" },
	{ key: "sy", value: "sy", flag: "sy", text: "Siria" },
	{ key: "sk", value: "sk", flag: "sk", text: "Slovacchia" },
	{ key: "si", value: "si", flag: "si", text: "Slovenia" },
	{ key: "so", value: "so", flag: "so", text: "Somalia" },
	{ key: "es", value: "es", flag: "es", text: "Spagna" },
	{ key: "lk", value: "lk", flag: "lk", text: "Sri Lanka" },
	{ key: "us", value: "us", flag: "us", text: "Stati Uniti" },
	{ key: "za", value: "za", flag: "za", text: "Sudafrica" },
	{ key: "sd", value: "sd", flag: "sd", text: "Sudan" },
	{ key: "sr", value: "sr", flag: "sr", text: "Suriname" },
	{ key: "sj", value: "sj", flag: "sj", text: "Svalbard e Jan Mayen" },
	{ key: "se", value: "se", flag: "se", text: "Svezia" },
	{ key: "ch", value: "ch", flag: "ch", text: "Svizzera" },
	{ key: "sz", value: "sz", flag: "sz", text: "eSwatini" },
	{ key: "tw", value: "tw", flag: "tw", text: "Taiwan" },
	{ key: "tj", value: "tj", flag: "tj", text: "Tagikistan" },
	{ key: "tz", value: "tz", flag: "tz", text: "Tanzania" },
	{
		key: "tf",
		value: "tf",
		flag: "tf",
		text: "Terre australi e antartiche francesi",
	},
	{
		key: "io",
		value: "io",
		flag: "io",
		text: "Territorio britannico dell'Oceano Indiano",
	},
	{ key: "th", value: "th", flag: "th", text: "Thailandia" },
	{ key: "tl", value: "tl", flag: "tl", text: "Timor Est" },
	{ key: "tg", value: "tg", flag: "tg", text: "Togo" },
	{ key: "tk", value: "tk", flag: "tk", text: "Tokelau" },
	{ key: "to", value: "to", flag: "to", text: "Tonga" },
	{ key: "tt", value: "tt", flag: "tt", text: "Trinidad e Tobago" },
	{ key: "tn", value: "tn", flag: "tn", text: "Tunisia" },
	{ key: "tr", value: "tr", flag: "tr", text: "Turchia" },
	{ key: "tm", value: "tm", flag: "tm", text: "Turkmenistan" },
	{ key: "tc", value: "tc", flag: "tc", text: "Turks e Caicos" },
	{ key: "tv", value: "tv", flag: "tv", text: "Tuvalu" },
	{ key: "ua", value: "ua", flag: "ua", text: "Ucraina" },
	{ key: "ug", value: "ug", flag: "ug", text: "Uganda" },
	{ key: "hu", value: "hu", flag: "hu", text: "Ungheria" },
	{ key: "uy", value: "uy", flag: "uy", text: "Uruguay" },
	{ key: "uz", value: "uz", flag: "uz", text: "Uzbekistan" },
	{ key: "vu", value: "vu", flag: "vu", text: "Vanuatu" },
	{ key: "ve", value: "ve", flag: "ve", text: "Venezuela" },
	{ key: "vn", value: "vn", flag: "vn", text: "Vietnam" },
	{ key: "wf", value: "wf", flag: "wf", text: "Wallis e Futuna" },
	{ key: "ye", value: "ye", flag: "ye", text: "Yemen" },
	{ key: "zm", value: "zm", flag: "zm", text: "Zambia" },
	{ key: "zw", value: "zw", flag: "zw", text: "Zimbabwe" },
];

export const COUNTRY_ITA = [{ key: "it", value: "it", flag: "it", text: "Italia" }];

export const COUNTRIES_PREFIX = [
	{ key: "", value: "", flag: "", text: "" },
	{ key: "af", value: "+93", flag: "af", text: "+93" },
	{ key: "ax", value: "+358", flag: "ax", text: "+358" },
	{ key: "al", value: "+355", flag: "al", text: "+355" },
	{ key: "dz", value: "+213", flag: "dz", text: "+213" },
	{ key: "as", value: "+1684", flag: "as", text: "+1684" },
	{ key: "ad", value: "+376", flag: "ad", text: "+376" },
	{ key: "ao", value: "+244", flag: "ao", text: "+244" },
	{ key: "ai", value: "+1264", flag: "ai", text: "+1264" },
	{ key: "ag", value: "+1268", flag: "ag", text: "+1268" },
	{ key: "ar", value: "+54", flag: "ar", text: "+54" },
	{ key: "am", value: "+374", flag: "am", text: "+374" },
	{ key: "aw", value: "+297", flag: "aw", text: "+297" },
	{ key: "au", value: "+61", flag: "au", text: "+61" },
	{ key: "at", value: "+43", flag: "at", text: "+43" },
	{ key: "az", value: "+994", flag: "az", text: "+994" },
	{ key: "bs", value: "+1242", flag: "bs", text: "+1242" },
	{ key: "bh", value: "+973", flag: "bh", text: "+973" },
	{ key: "bd", value: "+880", flag: "bd", text: "+880" },
	{ key: "bb", value: "+1246", flag: "bb", text: "+1246" },
	{ key: "by", value: "+375", flag: "by", text: "+375" },
	{ key: "be", value: "+32", flag: "be", text: "+32" },
	{ key: "bz", value: "+501", flag: "bz", text: "+501" },
	{ key: "bj", value: "+229", flag: "bj", text: "+229" },
	{ key: "bm", value: "+1441", flag: "bm", text: "+1441" },
	{ key: "bt", value: "+975", flag: "bt", text: "+975" },
	{ key: "bo", value: "+591", flag: "bo", text: "+591" },
	{ key: "ba", value: "+387", flag: "ba", text: "+387" },
	{ key: "bw", value: "+267", flag: "bw", text: "+267" },
	{ key: "br", value: "+55", flag: "br", text: "+55" },
	{ key: "io", value: "+246", flag: "io", text: "+246" },
	{ key: "bn", value: "+673", flag: "bn", text: "+673" },
	{ key: "bg", value: "+359", flag: "bg", text: "+359" },
	{ key: "bf", value: "+226", flag: "bf", text: "+226" },
	{ key: "bi", value: "+257", flag: "bi", text: "+257" },
	{ key: "kh", value: "+855", flag: "kh", text: "+855" },
	{ key: "cm", value: "+237", flag: "cm", text: "+237" },
	{ key: "ca", value: "+1", flag: "ca", text: "+1" },
	{ key: "cv", value: "+238", flag: "cv", text: "+238" },
	{ key: "ky", value: "+345", flag: "ky", text: "+345" },
	{ key: "cf", value: "+236", flag: "cf", text: "+236" },
	{ key: "td", value: "+235", flag: "td", text: "+235" },
	{ key: "cl", value: "+56", flag: "cl", text: "+56" },
	{ key: "cn", value: "+86", flag: "cn", text: "+86" },
	{ key: "cx", value: "+61", flag: "cx", text: "+61" },
	{ key: "cc", value: "+61", flag: "cc", text: "+61" },
	{ key: "co", value: "+57", flag: "co", text: "+57" },
	{ key: "km", value: "+269", flag: "km", text: "+269" },
	{ key: "cg", value: "+242", flag: "cg", text: "+242" },
	{ key: "cd", value: "+243", flag: "cd", text: "+243" },
	{ key: "ck", value: "+682", flag: "ck", text: "+682" },
	{ key: "cr", value: "+506", flag: "cr", text: "+506" },
	{ key: "ci", value: "+225", flag: "ci", text: "+225" },
	{ key: "hr", value: "+385", flag: "hr", text: "+385" },
	{ key: "cu", value: "+53", flag: "cu", text: "+53" },
	{ key: "cy", value: "+357", flag: "cy", text: "+357" },
	{ key: "cz", value: "+420", flag: "cz", text: "+420" },
	{ key: "dk", value: "+45", flag: "dk", text: "+45" },
	{ key: "dj", value: "+253", flag: "dj", text: "+253" },
	{ key: "dm", value: "+1767", flag: "dm", text: "+1767" },
	{ key: "do", value: "+1849", flag: "do", text: "+1849" },
	{ key: "ec", value: "+593", flag: "ec", text: "+593" },
	{ key: "eg", value: "+20", flag: "eg", text: "+20" },
	{ key: "sv", value: "+503", flag: "sv", text: "+503" },
	{ key: "gq", value: "+240", flag: "gq", text: "+240" },
	{ key: "er", value: "+291", flag: "er", text: "+291" },
	{ key: "ee", value: "+372", flag: "ee", text: "+372" },
	{ key: "et", value: "+251", flag: "et", text: "+251" },
	{ key: "fk", value: "+500", flag: "fk", text: "+500" },
	{ key: "fo", value: "+298", flag: "fo", text: "+298" },
	{ key: "fj", value: "+679", flag: "fj", text: "+679" },
	{ key: "fi", value: "+358", flag: "fi", text: "+358" },
	{ key: "fr", value: "+33", flag: "fr", text: "+33" },
	{ key: "gf", value: "+594", flag: "gf", text: "+594" },
	{ key: "pf", value: "+689", flag: "pf", text: "+689" },
	{ key: "ga", value: "+241", flag: "ga", text: "+241" },
	{ key: "gm", value: "+220", flag: "gm", text: "+220" },
	{ key: "ge", value: "+995", flag: "ge", text: "+995" },
	{ key: "de", value: "+49", flag: "de", text: "+49" },
	{ key: "gh", value: "+233", flag: "gh", text: "+233" },
	{ key: "gi", value: "+350", flag: "gi", text: "+350" },
	{ key: "gr", value: "+30", flag: "gr", text: "+30" },
	{ key: "gl", value: "+299", flag: "gl", text: "+299" },
	{ key: "gd", value: "+1473", flag: "gd", text: "+1473" },
	{ key: "gp", value: "+590", flag: "gp", text: "+590" },
	{ key: "gu", value: "+1671", flag: "gu", text: "+1671" },
	{ key: "gt", value: "+502", flag: "gt", text: "+502" },
	{ key: "gn", value: "+224", flag: "gn", text: "+224" },
	{ key: "gw", value: "+245", flag: "gw", text: "+245" },
	{ key: "gy", value: "+595", flag: "gy", text: "+595" },
	{ key: "ht", value: "+509", flag: "ht", text: "+509" },
	{ key: "va", value: "+379", flag: "va", text: "+379" },
	{ key: "hn", value: "+504", flag: "hn", text: "+504" },
	{ key: "hk", value: "+852", flag: "hk", text: "+852" },
	{ key: "hu", value: "+36", flag: "hu", text: "+36" },
	{ key: "is", value: "+354", flag: "is", text: "+354" },
	{ key: "in", value: "+91", flag: "in", text: "+91" },
	{ key: "id", value: "+62", flag: "id", text: "+62" },
	{ key: "ir", value: "+98", flag: "ir", text: "+98" },
	{ key: "iq", value: "+964", flag: "iq", text: "+964" },
	{ key: "ie", value: "+353", flag: "ie", text: "+353" },
	{ key: "il", value: "+972", flag: "il", text: "+972" },
	{ key: "it", value: "+39", flag: "it", text: "+39" },
	{ key: "jm", value: "+1876", flag: "jm", text: "+1876" },
	{ key: "jp", value: "+81", flag: "jp", text: "+81" },
	{ key: "jo", value: "+962", flag: "jo", text: "+962" },
	{ key: "kz", value: "+77", flag: "kz", text: "+77" },
	{ key: "ke", value: "+254", flag: "ke", text: "+254" },
	{ key: "ki", value: "+686", flag: "ki", text: "+686" },
	{ key: "kp", value: "+850", flag: "kp", text: "+850" },
	{ key: "kr", value: "+82", flag: "kr", text: "+82" },
	{ key: "kw", value: "+965", flag: "kw", text: "+965" },
	{ key: "kg", value: "+996", flag: "kg", text: "+996" },
	{ key: "la", value: "+856", flag: "la", text: "+856" },
	{ key: "lv", value: "+371", flag: "lv", text: "+371" },
	{ key: "lb", value: "+961", flag: "lb", text: "+961" },
	{ key: "ls", value: "+266", flag: "ls", text: "+266" },
	{ key: "lr", value: "+231", flag: "lr", text: "+231" },
	{ key: "ly", value: "+218", flag: "ly", text: "+218" },
	{ key: "li", value: "+423", flag: "li", text: "+423" },
	{ key: "lt", value: "+370", flag: "lt", text: "+370" },
	{ key: "lu", value: "+352", flag: "lu", text: "+352" },
	{ key: "mo", value: "+853", flag: "mo", text: "+853" },
	{ key: "mk", value: "+389", flag: "mk", text: "+389" },
	{ key: "mg", value: "+261", flag: "mg", text: "+261" },
	{ key: "mw", value: "+265", flag: "mw", text: "+265" },
	{ key: "my", value: "+60", flag: "my", text: "+60" },
	{ key: "mv", value: "+960", flag: "mv", text: "+960" },
	{ key: "ml", value: "+223", flag: "ml", text: "+223" },
	{ key: "mt", value: "+356", flag: "mt", text: "+356" },
	{ key: "mh", value: "+692", flag: "mh", text: "+692" },
	{ key: "mq", value: "+596", flag: "mq", text: "+596" },
	{ key: "mr", value: "+222", flag: "mr", text: "+222" },
	{ key: "mu", value: "+230", flag: "mu", text: "+230" },
	{ key: "yt", value: "+262", flag: "yt", text: "+262" },
	{ key: "mx", value: "+52", flag: "mx", text: "+52" },
	{ key: "fm", value: "+691", flag: "fm", text: "+691" },
	{ key: "md", value: "+373", flag: "md", text: "+373" },
	{ key: "mc", value: "+377", flag: "mc", text: "+377" },
	{ key: "mn", value: "+976", flag: "mn", text: "+976" },
	{ key: "me", value: "+382", flag: "me", text: "+382" },
	{ key: "ms", value: "+1664", flag: "ms", text: "+1664" },
	{ key: "ma", value: "+212", flag: "ma", text: "+212" },
	{ key: "mz", value: "+258", flag: "mz", text: "+258" },
	{ key: "mm", value: "+95", flag: "mm", text: "+95" },
	{ key: "na", value: "+264", flag: "na", text: "+264" },
	{ key: "nr", value: "+674", flag: "nr", text: "+674" },
	{ key: "np", value: "+977", flag: "np", text: "+977" },
	{ key: "nl", value: "+31", flag: "nl", text: "+31" },
	{ key: "an", value: "+599", flag: "an", text: "+599" },
	{ key: "nc", value: "+687", flag: "nc", text: "+687" },
	{ key: "nz", value: "+64", flag: "nz", text: "+64" },
	{ key: "ni", value: "+505", flag: "ni", text: "+505" },
	{ key: "ne", value: "+227", flag: "ne", text: "+227" },
	{ key: "ng", value: "+234", flag: "ng", text: "+234" },
	{ key: "nu", value: "+683", flag: "nu", text: "+683" },
	{ key: "nf", value: "+672", flag: "nf", text: "+672" },
	{ key: "mp", value: "+1670", flag: "mp", text: "+1670" },
	{ key: "no", value: "+47", flag: "no", text: "+47" },
	{ key: "om", value: "+968", flag: "om", text: "+968" },
	{ key: "pk", value: "+92", flag: "pk", text: "+92" },
	{ key: "pw", value: "+680", flag: "pw", text: "+680" },
	{ key: "ps", value: "+970", flag: "ps", text: "+970" },
	{ key: "pa", value: "+507", flag: "pa", text: "+507" },
	{ key: "pg", value: "+675", flag: "pg", text: "+675" },
	{ key: "py", value: "+595", flag: "py", text: "+595" },
	{ key: "pe", value: "+51", flag: "pe", text: "+51" },
	{ key: "ph", value: "+63", flag: "ph", text: "+63" },
	{ key: "pn", value: "+872", flag: "pn", text: "+872" },
	{ key: "pl", value: "+48", flag: "pl", text: "+48" },
	{ key: "pt", value: "+351", flag: "pt", text: "+351" },
	{ key: "pr", value: "+1939", flag: "pr", text: "+1939" },
	{ key: "qa", value: "+974", flag: "qa", text: "+974" },
	{ key: "ro", value: "+40", flag: "ro", text: "+40" },
	{ key: "ru", value: "+7", flag: "ru", text: "+7" },
	{ key: "rw", value: "+250", flag: "rw", text: "+250" },
	{ key: "re", value: "+262", flag: "re", text: "+262" },
	{ key: "sh", value: "+290", flag: "sh", text: "+290" },
	{ key: "kn", value: "+1869", flag: "kn", text: "+1869" },
	{ key: "lc", value: "+1758", flag: "lc", text: "+1758" },
	{ key: "pm", value: "+508", flag: "pm", text: "+508" },
	{ key: "vc", value: "+1784", flag: "vc", text: "+1784" },
	{ key: "ws", value: "+685", flag: "ws", text: "+685" },
	{ key: "sm", value: "+378", flag: "sm", text: "+378" },
	{ key: "st", value: "+239", flag: "st", text: "+239" },
	{ key: "sa", value: "+966", flag: "sa", text: "+966" },
	{ key: "sn", value: "+221", flag: "sn", text: "+221" },
	{ key: "rs", value: "+381", flag: "rs", text: "+381" },
	{ key: "sc", value: "+248", flag: "sc", text: "+248" },
	{ key: "sl", value: "+232", flag: "sl", text: "+232" },
	{ key: "sg", value: "+65", flag: "sg", text: "+65" },
	{ key: "sk", value: "+421", flag: "sk", text: "+421" },
	{ key: "si", value: "+386", flag: "si", text: "+386" },
	{ key: "sb", value: "+677", flag: "sb", text: "+677" },
	{ key: "so", value: "+252", flag: "so", text: "+252" },
	{ key: "za", value: "+27", flag: "za", text: "+27" },
	{ key: "gs", value: "+500", flag: "gs", text: "+500" },
	{ key: "es", value: "+34", flag: "es", text: "+34" },
	{ key: "lk", value: "+94", flag: "lk", text: "+94" },
	{ key: "sd", value: "+249", flag: "sd", text: "+249" },
	{ key: "sr", value: "+597", flag: "sr", text: "+597" },
	{ key: "sj", value: "+47", flag: "sj", text: "+47" },
	{ key: "sz", value: "+268", flag: "sz", text: "+268" },
	{ key: "se", value: "+46", flag: "se", text: "+46" },
	{ key: "ch", value: "+41", flag: "ch", text: "+41" },
	{ key: "sy", value: "+963", flag: "sy", text: "+963" },
	{ key: "tw", value: "+886", flag: "tw", text: "+886" },
	{ key: "tj", value: "+992", flag: "tj", text: "+992" },
	{ key: "tz", value: "+255", flag: "tz", text: "+255" },
	{ key: "th", value: "+66", flag: "th", text: "+66" },
	{ key: "tl", value: "+670", flag: "tl", text: "+670" },
	{ key: "tg", value: "+228", flag: "tg", text: "+228" },
	{ key: "tk", value: "+690", flag: "tk", text: "+690" },
	{ key: "to", value: "+676", flag: "to", text: "+676" },
	{ key: "tt", value: "+1868", flag: "tt", text: "+1868" },
	{ key: "tn", value: "+216", flag: "tn", text: "+216" },
	{ key: "tr", value: "+90", flag: "tr", text: "+90" },
	{ key: "tm", value: "+993", flag: "tm", text: "+993" },
	{ key: "tc", value: "+1649", flag: "tc", text: "+1649" },
	{ key: "tv", value: "+688", flag: "tv", text: "+688" },
	{ key: "ug", value: "+256", flag: "ug", text: "+256" },
	{ key: "ua", value: "+380", flag: "ua", text: "+380" },
	{ key: "ae", value: "+971", flag: "ae", text: "+971" },
	{ key: "gb", value: "+44", flag: "gb", text: "+44" },
	{ key: "us", value: "+1", flag: "us", text: "+1" },
	{ key: "uy", value: "+598", flag: "uy", text: "+598" },
	{ key: "uz", value: "+998", flag: "uz", text: "+998" },
	{ key: "vu", value: "+678", flag: "vu", text: "+678" },
	{ key: "ve", value: "+58", flag: "ve", text: "+58" },
	{ key: "vn", value: "+84", flag: "vn", text: "+84" },
	{ key: "vg", value: "+1284", flag: "vg", text: "+1284" },
	{ key: "vi", value: "+1340", flag: "vi", text: "+1340" },
	{ key: "wf", value: "+681", flag: "wf", text: "+681" },
	{ key: "ye", value: "+967", flag: "ye", text: "+967" },
	{ key: "zm", value: "+260", flag: "zm", text: "+260" },
	{ key: "zw", value: "+263", flag: "zw", text: "+263" },
];
